<youtube-player #player [videoId]="videoId" (ready)="onPlayerReady($event)" (stateChange)="onPlayerStateChange($event)"
    [width]="width" [height]="height"></youtube-player>